/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import DonutChart from './Charts/DonutChart';
import PieCharts from './Charts/PieChart';
import GlobalizationChart from './Charts/GlobalizationChart';
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import * as API from "../../framework/API/api";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import ColumnChart from './Charts/ColumnChart';
import AreaChart from './Charts/AreaChart';
import ActiveDashboardTile from './ActiveDashboardTile';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Loader } from "../../framework/forms/helpercomponents/Loader";
import 'hammerjs';
import BarGraph from "./Charts/BarGraph";
import SalesDashboardTile from "./SalesDashboardTile";
import MyStatusCell from "../../components/MyStatusCell";
import ToastNotification from "../../components/ToastNotification";
import { TOAST_TYPES } from "../../framework/constant/constant";

const BookingSummary = (props) => {

    const defaultDates = utility.getFirstAndLastDateOfMonth();
    const defaultParam = {
        FromDate: defaultDates.FirstDate,
        ToDate: defaultDates.LastDate,
        Channel: utility.getValue('BookingSummaryChannels') ?? {}
    }
    const [dataItem, setDataItem] = useState(defaultParam);
    const [isLoading, setIsLoading] = useState(false);
    const dataItemRef = useRef(defaultParam);
    const dataItemRefSetter = (data) => {
        dataItemRef.current = data;
        setDataItem(data);
    };

    const [channel, setChannel] = useState([]);

    const [dashBoardData, setDashBoardData] = useState({
        totalCount: props.bookingSummaryDashboardData.totalCount ?? 0,
        top10Agency: props.bookingSummaryDashboardData.top10Agency ?? 0,
        top10Client: props.bookingSummaryDashboardData.top10Client ?? 0,
        topRevenueByLocation: props.bookingSummaryDashboardData.topRevenueByLocation ?? 0,
        topBookingByDealType: props.bookingSummaryDashboardData.topBookingByDealType ?? 0,
        pendingVsOnAirBooking: props.bookingSummaryDashboardData.pendingVsOnAirBooking ?? 0,
        totalMonthlyRevenue: props.bookingSummaryDashboardData.totalMonthlyRevenue ?? 0,
        top5SalesExecutive: props.bookingSummaryDashboardData.top5SalesExecutive ?? 0,
        bookingScheduleAndPendingCount: props.bookingSummaryDashboardData.bookingScheduleAndPendingCount ?? [],
        salestargetvsachived: props.bookingSummaryDashboardData.salestargetvsachived ?? { data: [], categories: [] },
        bookingFinancialsTiles: props.bookingSummaryDashboardData.bookingFinancialsTiles ?? [],
        bookingFinancialsTable: { agencyRevenue: [], clientRevenue: [] },
        invoiceTable: { recentInvoices: [], pendingInvoices: [] }
    })
    const lang = useTranslation();
    const payloadRef = useRef({});

    const buttonStyle = { padding: "0 5px", display: "inline-block", backgroundColor: "white", height: '30px', }

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let channelRes = await API.getValidChannels();
        channelRes.data.unshift({ _id: null, FullChannelName: 'All' })
        setChannel(channelRes.data);
        if (channelRes.data.length > 0) {
            const selectedChanel = Object.keys(defaultParam.Channel).length > 0 ? defaultParam.Channel : utility.getDefaultItem(channelRes.data);
            dataItemRefSetter({ ...dataItem, Channel: selectedChanel })
            payloadRef.current = {
                channelsid: selectedChanel?._id ? selectedChanel.SID : null,
                startdate: new Date(dataItemRef.current.FromDate).getTime(),
                enddate: new Date(dataItemRef.current.ToDate).getTime()
            }

            for (const element of Object.keys(props.bookingSummaryDashboardData)) {
                const key = element;
                const value = props.bookingSummaryDashboardData[key];
                if (value.length == 0) {
                    loadData();
                    break;
                }
            }
        }
    }

    const isValid = () => {
        if (!utility.isValidDate(dataItemRef.current.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (!utility.isValidDate(dataItemRef.current.ToDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItemRef.current.FromDate > dataItemRef.current.ToDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_should_be_less_than_to_date_error_message });
            return false;
        }
        if (dataItemRef.current.Channel.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        return true;
    }

    const OnShow = async () => {

        if (isValid()) {
            payloadRef.current = {
                channelsid: dataItemRef.current.Channel?._id ? dataItemRef.current.Channel.SID : null,
                startdate: new Date(dataItemRef.current.FromDate).getTime(),
                enddate: new Date(dataItemRef.current.ToDate).getTime()
            }
            utility.setValue('BookingSummaryChannels', dataItemRef.current.Channel);
            loadData();
            console.log(dataItemRef.current.Channel)
            console.log(dataItemRef.current)
        }
    }
    const loadData = async () => {

        if (payloadRef.current == undefined) {
            return;
        }
        setIsLoading(true);
        let dashboardData = {
            totalCount: [],
            top10Agency: [],
            top10Client: [],
            topRevenueByLocation: [],
            topBookingByDealType: [],
            pendingVsOnAirBooking: [],
            totalMonthlyRevenue: [],
            top5SalesExecutive: [],
            currentDaysScheduleBookingPending: [],
            salestargetvsachived: { data: [], categories: [] },
            bookingFinancialsTiles: [],
            bookingFinancialsTable: { agencyRevenue: [], clientRevenue: [] },
            invoiceTable: { recentInvoices: [], pendingInvoices: [] }
        }

        let res = await API.getBookingSummaryDashboardData(payloadRef.current);
        let resSalesTargetvsAchived = await API.getSalesTargetvsAchived(payloadRef.current);

        if (res.success && resSalesTargetvsAchived.success) {

            dashboardData.totalCount = res.data.totalAndActiveCount;
            dashboardData.top10Agency = res.data.top10Agencies;
            dashboardData.top10Client = res.data.top10Clients;
            dashboardData.topRevenueByLocation = res.data.topLocations;
            dashboardData.topBookingByDealType = res.data.bookingByDealType;
            dashboardData.pendingVsOnAirBooking = res.data.airedAndPending;
            dashboardData.totalMonthlyRevenue = res.data.revenueByMonth;
            dashboardData.top5SalesExecutive = res.data.top5SalesExecutive;
            dashboardData.bookingScheduleAndPendingCount = res.data.bookingScheduleAndPendingCount;
            dashboardData.bookingFinancialsTiles = res.data.bookingFinancialsTiles;
            dashboardData.bookingFinancialsTable.agencyRevenue = res.data.bookingFinancialsTable.agencyRevenue;
            dashboardData.bookingFinancialsTable.clientRevenue = res.data.bookingFinancialsTable.clientRevenue;
            dashboardData.invoiceTable.recentInvoices = res.data.invoiceTable.recentInvoices;
            dashboardData.invoiceTable.pendingInvoices = res.data.invoiceTable.pendingInvoices;

            //FROM DIFFERENT API
            dashboardData.salestargetvsachived = { data: resSalesTargetvsAchived.data?.data ?? [], categories: resSalesTargetvsAchived.data?.quarter ?? [] }

        } else {
            console.log(res.message)
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: !res.success ? res.message : resSalesTargetvsAchived.message });
            return;
        }

        setDashBoardData(dashboardData);
        props.setBookingSummaryDashboardData(dashboardData);
        setIsLoading(false);

    }

    const onChange = (e) => {
        dataItemRefSetter({ ...dataItem, [e.target.name]: e.target.value });
    }

    const topSalesExecutivelabel = (props) => {
        return `${props.dataItem.name} Total : ${props.dataItem.value}`;
    };

    const topAgencylabel = (props) => {
        return `${props.dataItem.name} Total : ${props.dataItem.value}`;
    };

    // User For Revenue By Location
    let locationTotalsr = [];
    let locationName = [];

    if (dashBoardData.topRevenueByLocation != undefined && dashBoardData.topRevenueByLocation.length > 0) {
        dashBoardData.topRevenueByLocation.map((item) => {
            locationTotalsr.push(item.totalsr);
            locationName.push(item.name);

        })
    }

    // User For Revenue By Months
    let monthTotalsr = [];
    let monthName = [];
    if (dashBoardData.totalMonthlyRevenue != undefined && dashBoardData.totalMonthlyRevenue.length > 0) {
        dashBoardData.totalMonthlyRevenue.map((item) => {
            monthTotalsr.push(item.totalRevenue);
            monthName.push(item.months);

        })
    }

    const sectionContainerStyle = {
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        padding: "12px",
    };

    const sectionTitleStyle = {
        fontSize: "14px",
        fontWeight: 600,
        color: "#333",
        marginBottom: "6px"
    };

    const dividerStyle = {
        border: "none",
        borderTop: "1px solid #e5e7eb",
        margin: "6px 0 12px 0"
    };

  const Mystatuscell = (props) => {
    const { dataItem } = props;

    let title = "";
    let tileBackColor = "";

    const status = dataItem?.IsPaymentReceived;
    if (status === false) {
      title = "Bill Generated";
      tileBackColor = "#FE9328";
    } else if (status === true) {
      title = "Payment Received";
      tileBackColor = "#28a745";
    }

    return (
      <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
    );
  };

    return (
        <div className="row">
            <div className='col-12 mb-3'>
                <div className="row form-group">
                    <div className="col-2">
                        <label htmlFor="">{lang.from_date_label} </label>
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            name="FromDate"
                            value={dataItem.FromDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-2">
                        <label htmlFor="">{lang.to_date_label} </label>
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            name="ToDate"
                            value={dataItem.ToDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4">
                        <label htmlFor="TabView">{lang.channel_label} *</label><br />
                        <DropDownList
                            style={{
                                backgroundColor: "white",
                            }}
                            data={channel}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.Channel}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col" style={{ textAlign: "left", marginTop: "20px" }}>
                        <ActionButton title={lang.show_button_tooltip} name={lang.show_button_text} onClick={OnShow} />
                    </div>
                </div>
                <div className="widget-body ml-2">
                    <div className="row g-3">
                        {/* Client Count */}
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#CA4D27"
                                count={dashBoardData.totalCount.totalClientCount ?? 0}
                                icon="fa-sharp fa-solid fa-user"
                                status={lang.client_label}
                                description={`Active: ${dashBoardData.totalCount.totalActiveClientCount ?? 0}`}
                                route="/home/Client"
                            />
                        </div>
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#DEB632"
                                count={dashBoardData.totalCount.totalAgencyCount ?? 0}
                                icon="fa-sharp fa-solid fa-landmark"
                                status={lang.agency_label}
                                description={`Active: ${dashBoardData.totalCount.totalActiveAgencyCount ?? 0}`}
                                route="/home/Agency"
                            />
                        </div>
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#23A8E8"
                                count={dashBoardData.totalCount.totalCampaignCount ?? 0}
                                icon="fa-sharp fa-solid fa-kaaba"
                                status={lang.campaign_label}
                                description={`Active: ${dashBoardData.totalCount.totalActiveCampaignCount ?? 0}`}
                                route="/home/Campaign"
                            />
                        </div>
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#7458E0"
                                count={dashBoardData.totalCount.totalExecutiveCount ?? 0}
                                icon="fa-sharp fa-solid fa-users"
                                status={lang.executive_label}
                                description={`Active: ${dashBoardData.totalCount.totalActiveExecutiveCount ?? 0}`}
                                route="/home/users/SalesExecutive"
                            />
                        </div>
                    </div>
                </div>

                <div className="widget-body ml-2">
                    <div className="row g-3">
                        {/* Client Count */}
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#1ca666"
                                count={dashBoardData.bookingFinancialsTiles?.totalBookedAmount ?? 0}
                                icon="fa-sharp fa-solid fa-user"
                                status={lang.total_booked_amount_label}
                                description={lang.view_details_label}
                            />
                        </div>
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#98BC62"
                                count={dashBoardData.bookingFinancialsTiles?.missingSpotsAmount ?? 0}
                                icon="fa-sharp fa-solid fa-landmark"
                                status={lang.missing_spots_amount_label}
                                description={lang.view_details_label}
                            />
                        </div>
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#c72848"
                                count={dashBoardData.bookingFinancialsTiles?.billedAmount ?? 0}
                                icon="fa-sharp fa-solid fa-kaaba"
                                status={lang.billed_amount_label}
                                description={lang.view_details_label}
                            />
                        </div>
                        <div className="summaryDashboard_forCard col-sm-12 col-md-6 col-lg-3 col-xl-3">
                            <SalesDashboardTile
                                iconBackColor="#3c83c9"
                                count={dashBoardData.bookingFinancialsTiles?.paymentRecievedAmount ?? 0}
                                icon="fa-sharp fa-solid fa-users"
                                status={lang.payment_recieved_label}
                                description={lang.view_details_label}
                            />
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className="col-md-6">
                        <PieCharts title={lang.top_10_agency_label} root={`/home/Agency`} listData={dashBoardData.top10Agency} label={topAgencylabel} isLoading={isLoading} ></PieCharts>
                    </div>
                    <div className="col-md-6">
                        <DonutChart title={lang.top_10_client_label} root={`/home/Client`} listData={dashBoardData.top10Client} isLoading={isLoading}></DonutChart>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-6">
                        <PieCharts title={lang.top_5_sales_executive_label} root={`/home/users/SalesExecutive`} listData={dashBoardData.top5SalesExecutive} label={topSalesExecutivelabel} isLoading={isLoading} ></PieCharts>
                    </div>
                    <div className="col-md-6">
                        <AreaChart pendingVsOnAirBooking={dashBoardData.pendingVsOnAirBooking} isLoading={isLoading}></AreaChart>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-6">
                        <GlobalizationChart name={locationName} totaldata={dashBoardData.topRevenueByLocation} title={lang.revenue_by_location_label} isLoading={isLoading} />
                    </div>
                    <div className="col-md-6">
                        <ColumnChart chartData={dashBoardData.topBookingByDealType} categories={[]} isLoading={isLoading} title={lang.booking_by_deal_type_label}></ColumnChart>
                    </div>

                </div>

                <div className='row'>
                    <div className="col-md-6">
                        <GlobalizationChart name={monthName} totaldata={monthTotalsr} title={lang.revenue_by_months_label} isLoading={isLoading} />
                    </div>
                    <div className="col-md-6">
                        <BarGraph chartData={dashBoardData.salestargetvsachived.data} categories={dashBoardData.salestargetvsachived.categories} isLoading={isLoading} title={lang.sales_target_achived_label}></BarGraph>
                    </div>
                </div>

                <div className='row mb-3'>
                    <div className="col-lg-6">
                        <div style={sectionContainerStyle}>
                            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>{lang.agency_wise_revenue_label}</span>
                            </div>
                            <hr style={dividerStyle} />
                            {isLoading ?
                                <Loader height="29vh" bgColor="white" /> :
                                <Grid data={dashBoardData.bookingFinancialsTable.agencyRevenue} style={{ height: "282px", width: "100%", overflowY: "auto" }}>
                                    <Column width="220px" field="agencyName" title="Agency Name" />
                                    <Column field="totalRevenue" title="Total Revenue" />
                                    <Column field="totalSpots" title="Total Spots" />
                                </Grid>}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div style={sectionContainerStyle}>
                            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>{lang.client_wise_revenue_label}</span>
                            </div>
                            <hr style={dividerStyle} />
                            {isLoading ?
                                <Loader height="29vh" bgColor="white" /> :
                                <Grid data={dashBoardData.bookingFinancialsTable.clientRevenue} style={{ height: "282px", width: "100%", overflowY: "auto" }}>
                                    <Column width="220px" field="clientName" title="Client Name" />
                                    <Column field="totalRevenue" title="Total Revenue" />
                                    <Column field="totalSpots" title="Total Spots" />
                                </Grid>}
                        </div>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className="col-lg-6">
                        <div style={sectionContainerStyle}>
                            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>{lang.recent_invoices_label}</span>
                            </div>
                            <hr style={dividerStyle} />
                            {isLoading ?
                                <Loader height="29vh" bgColor="white" /> :
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                    <Grid data={dashBoardData.invoiceTable.recentInvoices} style={{ height: 282, minWidth: 950 }} scrollable="scrollable">
                                        <Column width={150} field="InvoiceNo" title="Invoice Number" />
                                        <Column width={150} field="IsPaymentReceived" title="Status" cell={Mystatuscell} />
                                        <Column width={180} field="Agency.Name" title="Agency Name" />
                                        <Column width={180} field="Campaign.Title" title="Campaign" />
                                        <Column width={130} field="TotalAmount" title="Total Amount" />
                                        <Column width={120} field="TotalSpots" title="Total Spots" />
                                        <Column width={180} field="Channel.FullChannelName" title="Channel" />
                                    </Grid>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div style={sectionContainerStyle}>
                            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>{lang.pending_invoices_label}</span>
                            </div>
                            <hr style={dividerStyle} />
                            {isLoading ?
                                <Loader height="29vh" bgColor="white" /> :
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                    <Grid data={dashBoardData.invoiceTable.pendingInvoices} style={{ height: 282, minWidth: 950 }} scrollable="scrollable">
                                        <Column width={150} field="InvoiceNo" title="Invoice Number" />
                                        <Column width={150} field="IsPaymentReceived" title="Status" cell={Mystatuscell} />
                                        <Column width={180} field="Agency.Name" title="Agency Name" />
                                        <Column width={180} field="Campaign.Title" title="Campaign" />
                                        <Column width={130} field="TotalAmount" title="Total Amount" />
                                        <Column width={120} field="TotalSpots" title="Total Spots" />
                                        <Column width={180} field="Channel.FullChannelName" title="Channel" />
                                    </Grid>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className='col-6'>
                        <div className="panel panel-default" style={{ height: "350px", color: "#333", backgroundColor: "#f5f5f5", borderColor: "#ddd" }}>
                            <div className="panel-heading" style={{
                                borderColor: "1px solid transparent", borderBottom: "1px solid transparent", borderTopRightRadius: "1px"
                                , borderTopLeftRadius: "1px", textAlignLast: "center"
                            }}>{lang.tomorrow_pending_booking_status_label}
                            </div>
                            {isLoading ?
                                <Loader height="30.5vh" bgColor="white" /> :
                                <div className="panel-body" style={{ height: "300px", display: "block", width: "100%", backgroundColor: 'white' }}>
                                    <Grid data={dashBoardData.bookingScheduleAndPendingCount} resizable={true} >
                                        <Column field="ChannelName" title={lang.channel_name_column} />
                                        <Column field="total" title={lang.total_column} />
                                        <Column field="schedule" title={lang.schudule_column} />
                                        <Column field="pending" title={lang.pending_colun} />
                                    </Grid>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BookingSummary;
